// AlertMessage.js
import React,{useEffect} from "react";

const AlertMessage = ({ message, type = "success", timeout = 3000, onClear }) => {
    useEffect(() => {
        if (message) {
          const timer = setTimeout(() => {
            onClear();
          }, timeout);
          return () => clearTimeout(timer);
        }
      }, [message, timeout, onClear]);
    
      if (!message) return null;
    
      const alertClass =
        type === "success"
          ? "success alert alert-success small"
          : "error alert alert-danger small";
    
      return (
        <div style={{ display: "block" }} className={alertClass}>
          {message}
        </div>
      );
};

export default AlertMessage;